<template>
    <div class="fcf-check">

    <b-collapse class="panel" :open.sync="isOpen">
      <panel-heading slot="trigger" :title="'Matters to be dealt with before closing a file (please check relevant boxes when complete)'" :edit-not-allowed="editNotAllowed"/>

      <div class="panel-block">
        <div class="fcf-check__row">
          <div class=""></div>
          <div class="column-header">Completed</div>
          <div class="column-header">N/A</div>
        </div>
        <fcf-check-row
          :id="'physicalFilesCollected'"
          :value="localChecksData.physicalFilesCollected"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'staffInformed'"
          :value="localChecksData.staffInformed"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'emailsCollected'"
          :value="localChecksData.emailsCollected"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'documentsDmSaved'"
          :value="localChecksData.documentsDmSaved"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'originalsReturned'"
          :value="localChecksData.originalsReturned"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'archiveAndUsbCreated'"
          :value="localChecksData.archiveAndUsbCreated"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'knowHowPassed'"
          :value="localChecksData.knowHowPassed"
          :has-na="true"
          :na-id="'knowHowPassedNA'"
          :na-value="localChecksData.knowHowPassedNA"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'marketingPassed'"
          :value="localChecksData.marketingPassed"
          :has-na="true"
          :na-id="'marketingPassedNA'"
          :na-value="localChecksData.marketingPassedNA"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'signedMandatePassed'"
          :value="localChecksData.signedMandatePassed"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'kycFiled'"
          :value="localChecksData.kycFiled"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'bibleCompleted'"
          :value="localChecksData.bibleCompleted"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />
        <fcf-check-row
          :id="'accountsDepInformed'"
          :value="localChecksData.accountsDepInformed"
          :edit-not-allowed="editNotAllowed"
          @value-changed="onValueChanged"
        />

      </div>
    </b-collapse>
  </div>
</template>

<script>
import FcfCheckRow from '@/components/FcfCheckRow'
import PanelHeading from '@/components/PanelHeading'

export default {
  name: 'FcfCheck',
  props: ['checksData', 'editNotAllowed'],
  components: {
    FcfCheckRow,
    PanelHeading
  },
  data () {
    return {
      localChecksData: this.checksData,
      isOpen: true
    }
  },
  methods: {
    onValueChanged (id, value) {
      console.log(id, value)
      this.$set(this.localChecksData, id, value)
      this.$emit('form-changed')
    }
  },
  watch: {
    checksData () {
      this.localChecksData = this.checksData
    }
  }
}
</script>

<style scoped>

.fcf-check {
  margin-bottom: 1em;
}

.fcf-check__row {
  align-items: center;
  display: grid;
  grid-column: 1/-1;
  grid-gap: 1em;
  grid-template-columns: 1.4fr 0.2fr 0.2fr;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}

.fcf-check__row--1 {
  grid-template-columns: 1fr;
}

.column-header {
  font-size: 1.1em;
  font-weight: bold;
  text-align: center;
}

.panel-block {
  display: grid;
  grid-gap: 1em;
}

</style>
